import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'sbpro-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['alert.component.scss'],
})
export class AlertComponent {
    @Input() classes!: string;
    @Input() dismissable = false;
    @Input() heading!: string;
    @Input() icon = false;
    @Output() closed = new EventEmitter<void>();

    dismissed = false;
    constructor() {}

    closeAlert() {
        this.dismissed = true;
        this.closed.emit();
    }
}
